import {
  useCountriesLookup,
  useDictionaryValues,
  useEpdAdditionalInformation,
  useEpdContentDeclarationProducts,
  useEpdConversionFactor,
  useEpdCoverPageInformation,
  useEpdDataSourceOptions,
  useEpdDataSources,
  useEPDDefinitionInformation,
  useEpdLcaCustomResults,
  useEpdLcaResults,
  useEpdLcaResultsAdditional,
  useEpdOrganizationInformation,
  useEpdOrganizationInformationAddress,
  useEpdProductInformation,
  useEpdReferenceFlow,
  useEpdScenarios,
  useEpdSystemBoundaryData,
  useEpdVerificationReportInfo,
  useFlowPropertiesLookup,
  useGetEpdCO2UptakeAssociation,
  useEpdCpcrSpecificData,
  useEpdSystemBoundaryGrid,
  useGetEpdLcaSupport,
  useGetEpdPCRInformation,
  useGetEpdThirdPartyVerification,
  useGetInfrastructureAndCapitalGoods,
  useGetLCASpecification,
  useLCASoftwareOptions,
  useReferencePackageVersions15804,
  useRegionsLookup,
  usePdfTemplateVersion,
} from 'services/api/queries';

export default function usePdfDataLoader(epdVersionId: string) {
  return nullWhenAnyPropIsUndefined({
    epdVersionId: epdVersionId,
    epdDefinition: useEPDDefinitionInformation(epdVersionId).data,
    verificationReport: useEpdVerificationReportInfo(epdVersionId).data,
    coverPageInformation: useEpdCoverPageInformation(epdVersionId).data,
    additionalInformation: useEpdAdditionalInformation(epdVersionId).data,
    products: useEpdProductInformation(epdVersionId).data,
    countries: useCountriesLookup().data,
    regions: useRegionsLookup().data,
    dictionaryValues: useDictionaryValues().data,
    organizationInformation: useEpdOrganizationInformation(epdVersionId).data,
    organizationInformationAddress: useEpdOrganizationInformationAddress(epdVersionId).data,
    pcrInformation: useGetEpdPCRInformation(epdVersionId).data,
    contentDeclaration: useEpdContentDeclarationProducts(epdVersionId).data,
    infrastructureAndCapitalGoods: useGetInfrastructureAndCapitalGoods(epdVersionId).data,
    lcaSpecification: useGetLCASpecification(epdVersionId).data,
    dataSources: useEpdDataSources(epdVersionId).data,
    systemBoundary: useEpdSystemBoundaryData(epdVersionId).data,
    scenarios: useEpdScenarios(epdVersionId).data,
    lcaSupport: useGetEpdLcaSupport(epdVersionId).data,
    lcaResults: useEpdLcaResults(epdVersionId).data?.lcaResults,
    lcaCustomResults: useEpdLcaCustomResults(epdVersionId).data,
    lcaResultsAdditional: useEpdLcaResultsAdditional(epdVersionId).data,
    dataSourceOptions: useEpdDataSourceOptions().data,
    referenceFlow: useEpdReferenceFlow(epdVersionId).data,
    conversionFactor: useEpdConversionFactor(epdVersionId).data,
    cO2UptakeAssociation: useGetEpdCO2UptakeAssociation(epdVersionId).data,
    lcaSoftwareOptions: useLCASoftwareOptions().data,
    referencePackageVersions15804: useReferencePackageVersions15804().data,
    flowPropertiesLookup: useFlowPropertiesLookup().data,
    thirdPartyVerification: useGetEpdThirdPartyVerification(epdVersionId).data,
    systemBoundaryGrid: useEpdSystemBoundaryGrid(epdVersionId).data,
    cpcrSpecificData: useEpdCpcrSpecificData(epdVersionId).data,
    pdfTemplateVersion: usePdfTemplateVersion().data,
  });
}

type HasNoUndefinedProperties<T> = {
  [K in keyof T]: Exclude<T[K], undefined>;
};

function nullWhenAnyPropIsUndefined<T extends { [key: string]: string | object | null | undefined }>(
  obj: T
): HasNoUndefinedProperties<T> | null {
  for (const key in obj) {
    if (obj[key] === undefined) {
      return null;
    }
  }

  return obj as HasNoUndefinedProperties<T>;
}
